import requestApi from '../../config';
import { useMutation } from '@tanstack/react-query';
import {
  LimitEnum,
  IResponseApi,
  IParamFilterLimitBet,
  DataHistoryBetting,
  HistoryBettingContent,
  IListVendor,
  IListGameByVendor,
  ERR_MSG,
  ERR_CODE,
  ISettingBetLimit
} from '@/interfaces';
import { useQuery } from '@tanstack/react-query';
import { showError, showSuccess } from '@/utils/alert';
import { useTranslation } from 'react-i18next';
import { MUTATIONS_KEY } from '@/interfaces/enum';
import { handleMsgError } from '@/utils/helpers';
const URL_LIST_VENDOR = '/adapter-service/limitation/vendor-list';
const URL_LIST_GAME = '/adapter-service/limitation/game-list-by-vendor';
const URL_SET_LIMIT = '/adapter-service/limitation/game-setting-bet';
const URL_DELETE_LIMIT = '/adapter-service/limitation/delete-game-bet';
const URL_EDIT_LIMIT = '/adapter-service/limitation/update-game-bet';
const URL_SEARCH_BET = '/adapter-service/limitation/history-setting-bet';
const URL_DOWLOAD_TEAMPLATE = "/adapter-service/limitation/game-list/download/template.xlsx"

export const useSettingBetLimit = () => {
  const { t } = useTranslation();
  return useMutation<IResponseApi<never>, IResponseApi<never>, ISettingBetLimit, number | string>(
    async (value) => {
      const data = await requestApi.post<never>(URL_SET_LIMIT, value);
      return data;
    },
    {
      onSuccess: async (value) => {
        await showSuccess(t(value.message));
      },
      onError: (error: { message: string }) => {
        handleMsgError(error.message, t)
      },
    },
  );
};

export const useListDataTable = () => {
  return useMutation(async (param: IParamFilterLimitBet) => {
    // const response = await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json');
    // const movies = await response.json();
    // const totalElements = movies.length;
    // const content = chunk(movies, param.page_size)[param.page_number] || [];
    // const url = '/auth-service/agents/list';
    const data = await requestApi.post<DataHistoryBetting>(URL_SEARCH_BET, param);

    return data;
  });
};
export const useLimitConfirmDelete = () => {
  const { t } = useTranslation();
  return useMutation(
    async ({ list, agent_id }: { list: HistoryBettingContent[]; agent_id: string }) => {
      const listDTO = list.map((x) => x.id);
      const param = {
        list: listDTO,
        agent_id,
      };
      const data = await requestApi.delete<null>(URL_DELETE_LIMIT, param);
      return data;
    },
    {
      onSuccess: async (val) => {
        await showSuccess(t(val.message)); // lam tiep cai nay
      },
      onError: async (error: { code: string, message: string }) => {
        if (error?.code === ERR_CODE.ERROR_NO_PERMISSION_DELETE_GAME_BET || error?.message === ERR_MSG.ERROR_NO_PERMISSION_DELETE) {
          await handleMsgError(t('limit.no_permission_delete_game_bet'), t)
        } else if (error?.message === ERR_MSG.ERROR_RECORD_NOT_FOUND) {
          await handleMsgError(t('common.data_deleted'), t)
        }
        else {
          await handleMsgError(error.code, t)
        }
      },
    },
  );
};

export const useLimitConfirmEdit = () => {
  const { t } = useTranslation();
  return useMutation(
    async ({ list, agent_id }: { list: HistoryBettingContent[]; agent_id: string }) => {
      const listDTO = list.map((x) => ({
        id: x.id,
        game_max_amount: x.amountLimit,
      }));
      // const listDTO = list.map((x) => x.id);
      const param = {
        list: listDTO,
        agent_id,
      };
      const data = await requestApi.put<null>(URL_EDIT_LIMIT, param);
      return data;
    },
    {
      onSuccess: async (val) => {
        await showSuccess(t(val.message));
      },
      onError: async (error: { message: string }) => {
        await handleMsgError(error.message, t)
      },
    },
  );
};


export const useListVendor = () => {
  return useQuery([LimitEnum.LIST_DATA_VENDOR_FORM], async () => {
    const { data } = await requestApi.get<IListVendor[]>(URL_LIST_VENDOR);
    return data;
  });
};

export const useListGameByVendor = (vendorKey: string) => {
  return useQuery<IListGameByVendor[], Error>(
    [LimitEnum.LIST_DATA_VENDOR_FORM, vendorKey],
    async () => {
      try {
        const { data } = await requestApi.get<IListGameByVendor[]>(URL_LIST_GAME, { vendorKey });
        return data;
      } catch (error) {
        throw new Error('Error fetching game list from vendor');
      }
    },
    {
      enabled: !!vendorKey,
    }
  );
};

const URL_UPLOAD_FILE = '/adapter-service/limitation/game-list/upload';
export const useUploadFile = () => {
  return useMutation([MUTATIONS_KEY.UPLOAD_FILE], async ({ file }: { file: FormData }) => {
    return await requestApi.uploadFile(URL_UPLOAD_FILE, file);
  });
};

const URL_DOWNLOAD_FILE = '/adapter-service/limitation/game-list/download/';
export const useDowloadFile = () => {
  return useMutation(async (param: string) => {
    const data = await requestApi.downloadFile(URL_DOWNLOAD_FILE + param);
    return data;
  });
};

export const useDowloadTeamplate = () => {
  return useMutation(async () => {
    const data = await requestApi.downloadFile(URL_DOWLOAD_TEAMPLATE);
    return data;
  });
};